
import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-gray-800">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">Effective Date: 01/06/2025</p>

      <p className="mb-4">
        Sous (“we”, “our”, or “us”) is committed to protecting your privacy.
        This Privacy Policy explains how we collect, use, and safeguard your
        information when you use our mobile app and services.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Account information (email, password)</li>
        <li>Preferences like cooking level, diet, pantry, etc.</li>
        <li>Images you upload for recipe suggestions</li>
        <li>Usage metrics to improve features</li>
        <li>Subscription transaction identifiers</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
      <p className="mb-4">
        We use data to personalize recipes, improve service, manage subscriptions,
        and provide helpful prompts like rating the app. We never sell or share
        your data with advertisers.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Security</h2>
      <p className="mb-4">
        Data is stored securely, transmitted with encryption, and access is limited
        to authorized personnel.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Your Rights</h2>
      <p className="mb-4">
        You may access, update, or delete your data at any time from your account,
        or request full deletion at <a href="/account" className="text-sage underline">sous.uk/account</a>.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Third-Party Services</h2>
      <p className="mb-4">We use services like Stripe, Apple, Google, and analytics tools with their own privacy terms.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Children’s Privacy</h2>
      <p className="mb-4">Sous is not for children under 18. We do not knowingly collect information from children.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Updates</h2>
      <p className="mb-4">We may update this policy and will notify users of major changes in-app or at sous.uk/privacy.</p>
    </div>
  );
}
